// @systeme: interface
// Les briques communes des écrans d'entrée : un titre, un formulaire, une erreur lisible.
import type { FormEvent, ReactNode } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface Props {
  titre: string;
  sousTitre?: string;
  erreur?: string;
  onSoumettre(e: FormEvent<HTMLFormElement>): void;
  children: ReactNode;
  pied?: ReactNode;
}

export function FormulaireAuth({ titre, sousTitre, erreur, onSoumettre, children, pied }: Props) {
  return (
    <Box>
      <Typography variant="h1" component="h1" gutterBottom>
        {titre}
      </Typography>
      {sousTitre && (
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          {sousTitre}
        </Typography>
      )}
      <Box component="form" onSubmit={onSoumettre} noValidate>
        <Stack spacing={2}>
          {erreur && (
            <Alert severity="info" icon={false}>
              {erreur}
            </Alert>
          )}
          {children}
        </Stack>
      </Box>
      {pied && <Box sx={{ mt: 3 }}>{pied}</Box>}
    </Box>
  );
}
